import React, { Component } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

// A Switcher should be paired with Pane components, see the Storybook file for examples.
export default class Switcher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPane: this.defaultSelectedPane,
    };
  }

  get defaultSelectedPane() {
    const { children } = this.props;

    const defaultPane = React.Children.toArray(children).find(
      (child) => child.props.default
    );
    if (defaultPane !== undefined) return defaultPane.props.title;

    return React.Children.toArray(children)[0].props.title;
  }

  handleButtonClick = (title) => {
    const { onSwitch } = this.props;
    this.setState({ selectedPane: title }, () => onSwitch(title));
  };

  renderButton = (title) => {
    const { selectedPane: controlledPane } = this.props;
    const { selectedPane: localPane } = this.state;
    const selectedPane = controlledPane || localPane;
    return (
      <button
        type="button"
        key={title}
        onClick={() => this.handleButtonClick(title)}
        className={cn(styles.button, {
          [styles.selected]: title === selectedPane,
        })}
      >
        {title}
      </button>
    );
  };

  render() {
    const { selectedPane: controlledPane } = this.props;
    const { selectedPane: localPane } = this.state;
    const selectedPane = controlledPane || localPane;
    const { children } = this.props;
    return (
      <div className={styles.switcher}>
        <div className={styles.menu} data-qa="switcher">
          {React.Children.map(
            children,
            (child) => child && this.renderButton(child.props.title)
          )}
        </div>
        {React.Children.toArray(children).find(
          (child) => child.props.title === selectedPane
        )}
      </div>
    );
  }
}

Switcher.propTypes = {
  children: PropTypes.node.isRequired,
  onSwitch: PropTypes.func,
  selectedPane: PropTypes.string,
};

Switcher.defaultProps = {
  onSwitch: () => {},
  selectedPane: null,
};
